/* function Log(props) -------------------

    maps the log sections for a specified log


  Children: ./LogSection
 
    parent: ./LogMain
------------------------------------*/


import React , {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useParams} from 'react-router-dom'

import { lightGrey, chitBurgandy } from '../../../styles/colors';

import { selectLogs } from '../../../app/redux/logRedux/logsSlice';
import { selectStatus, openLogForm } from '../../../app/redux/statusRedux/statusSlice';
import LogSection from './LogSection'

import { sortLogsByDateAscending, sortLogsByDateDescending,  logFilter } from '../../../app/helpers/chronicleHelpers';

import SliderComponent from '../components/SliderComponent';

//  ---- Material Ui ------------------
import Paper from '@mui/material/Paper'
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button'
import { styled, createTheme  } from "@mui/material/styles"
const theme = createTheme(); // allows use of mui theme in styled component

// ================================================

export default function Log() {
  let match = useParams()
  let id = match.id // get URL view location

  const dispatch = useDispatch()

  const status = useSelector(selectStatus)
  const displayStatus = status.view.log.sectionId

  /*
    get all logSections for logs
   
  */

  const allLogsArray = useSelector(selectLogs)

  const [allLogs, setAllLogs] = useState(allLogsArray)

  useEffect(()=>{

    setAllLogs(allLogsArray)

  },[allLogsArray])

  // --- filter the log sections by log Id ----
  console.log('[ Logs xxxxxxxxxxxxxxxxxxxxxxxx  ] allLogs ', allLogs);
  let filteredLogs = logFilter( [...allLogs], id)


console.log('[ Logs xxxxxxxxxxxxxxxxxxxxxxxx  ] filteredLogs ', filteredLogs);
  // --- order logs array (ascendding, descending)

  const [arrayOrder, setArrayOrder] = useState(false)

  var logsArray = [...allLogs]; // mutable copy of allLogsArray
  console.log('[ Logs xxxxxxxxxxxxxxxxxxxxxxxx  ] filteredLogs ', filteredLogs);
  console.log('[  Logs xxxxxxxxxxxxxxxxxxxxxxxx] arrayOrder ', arrayOrder);
  if(arrayOrder === true) {  filteredLogs = sortLogsByDateDescending(filteredLogs) }
  if(arrayOrder === false) { filteredLogs = sortLogsByDateAscending(filteredLogs) }

   const logRows = () =>

   filteredLogs.map((row, index) => {

     return (
      <SectionWrapper  key={row.id}> 
       <LogSection
         id={row.id}
         key={row.id}
         data={row}

       />
        </SectionWrapper>
     )
   }
   ) //end map


 

   const handleClick = ()=>{
 
   
    console.log('[ LOG HEADER] open new form ');
     dispatch(openLogForm('new'))
     
   }

   const handleSwitchState = (newState) => {
    newState === false? setArrayOrder(true): setArrayOrder(false)
    // 
  }
   
  return (
    <Wrapper>
            <FilterWrapper>

<SliderComponent
  handleSwitchState={handleSwitchState} //gets new state from child switch
  leftLabel='latest first'
  rightLabel='oldest first'
/>
</FilterWrapper>

      
   
      <> 
     {logRows()}
     </>
 
 

    </Wrapper>
  )
}


 
//--- STYLES begin --------------------------

const Wrapper= styled('div')({

  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  // backgroundColor: 'green',
  width: '100%',
  height: '100%',

overflow: 'auto',
  [theme.breakpoints.down('sm')] : {
    // width: '100%'
  },


})

const LogsMessageWrapper= styled(Paper)({

  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  // backgroundColor: 'green',
  width: '98%',
  height: '8rem',
  marginTop: '2rem',
  backgroundColor: lightGrey,
 
 
  [theme.breakpoints.down('sm')] : {
    // width: '100%'
  },


})

const MessageWrapper= styled('div')({

  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  justifyContent: 'enter',
  alignItems: 'center',
  color: chitBurgandy,
  marginBottom: '1rem',
  [theme.breakpoints.down('sm')] : {
    // width: '100%'
  },


})



const ButtonWrapper = styled('div')({
  display: 'flex',
  
  justifyContent: 'flex-end',
  alignItems: 'center',


[theme.breakpoints.down('sm')] : {
    // height: '1.25rem',
    // backgroundColor: 'red'
  },
})

const FormButton = styled(Button)({

 

  display: 'flex',
  textTransform: 'none',
  
 
  color: 'white',
  backgroundColor:  '#727376',
  fontWeight: 'normal',
  fontSize: '.85rem',
  padding: '0 1.5rem',
  width: '9.5rem',
  height: '1.2rem',
// margin: '0 1rem',
  
  '&:hover' : {
    // backgroundColor: chitBlueDull,
    textDecoration: 'none',
    border: '1px solid #A8BEED' ,
    color: '#3B30CC'

  }


})

const FilterWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  
// backgroundColor: 'yellow',
  width: '90%',
  padding: '0 12px',
  // height: '3rem',
  margin: '.5rem  0 .5rem 0',
 
  // height: '90%',

  
  // overflowY: 'hidden',

  [theme.breakpoints.down('sm')] : {
    // height: '1.25rem',

  },

})

const SectionWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',

  // margin: '1rem 0 ',
 
   
  width: '100%',

  // height: '8rem',
 


  [theme.breakpoints.down('sm')]: {
    // height: '1.25rem',

  },
})